import { render, staticRenderFns } from "./HandlingTypes.vue?vue&type=template&id=3c2dfa00"
import script from "./HandlingTypes.vue?vue&type=script&lang=js"
export * from "./HandlingTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports